module.exports = __webpack_public_path__ + "img/hope_36x50@2x.d7b122b9.png";